import { BaseCategory } from "~/types/baseCategory";

export const colorByBaseCategory: Record<BaseCategory, string> = {
  [BaseCategory.Politics]: "#334155",
  [BaseCategory.Elections]: "#3730A3",
  [BaseCategory.World]: "#334155",
  [BaseCategory.Financials]: "#14532D",
  [BaseCategory.Economics]: "#0F766E",
  [BaseCategory.Companies]: "#1E3A8A",
  [BaseCategory.Crypto]: "#6D28D9",
  [BaseCategory.ScienceAndTechnology]: "#1D4ED8",
  [BaseCategory.Education]: "#C2410C",
  [BaseCategory.Health]: "#B91C1C",
  [BaseCategory.ClimateAndWeather]: "#16A34A",
  [BaseCategory.Transportation]: "#57534E",
  [BaseCategory.Entertainment]: "#BE185D",
  [BaseCategory.Social]: "#7C3AED",
  [BaseCategory.Sports]: "#15803D",
  [BaseCategory.Other]: "#52525B",
  [BaseCategory.Mentions]: "#71717A",
  [BaseCategory.Commodities]: "#B45309",
};

export const bgColorByBaseCategory: Record<BaseCategory, string> = {
  [BaseCategory.Politics]: "#E2E8F0",
  [BaseCategory.Elections]: "#E0E7FF",
  [BaseCategory.World]: "#F1F5F9",
  [BaseCategory.Financials]: "#DCFCE7",
  [BaseCategory.Economics]: "#CCFBF1",
  [BaseCategory.Companies]: "#DBEAFE",
  [BaseCategory.Crypto]: "#EDE9FE",
  [BaseCategory.ScienceAndTechnology]: "#E0F2FE",
  [BaseCategory.Education]: "#FFEDD5",
  [BaseCategory.Health]: "#FEE2E2",
  [BaseCategory.ClimateAndWeather]: "#ECFDF5",
  [BaseCategory.Transportation]: "#F5F5F4",
  [BaseCategory.Entertainment]: "#FCE7F3",
  [BaseCategory.Social]: "#F3E8FF",
  [BaseCategory.Sports]: "#DCFCE7",
  [BaseCategory.Other]: "#F4F4F5",
  [BaseCategory.Mentions]: "#FAFAFA",
  [BaseCategory.Commodities]: "#FEF3C7",
};
